import { Params, RouterStateSnapshot } from '@angular/router';
import { RouterStateSerializer } from '@ngrx/router-store';
import { Injectable } from '@angular/core';

/**
 * The RouterStateSerializer takes the current RouterStateSnapshot
 * and returns any pertinent information needed. The snapshot contains
 * all information about the state of the router at the given point in time.
 * The entire snapshot is complex and not always needed. In this case, we only
 * return the URL and query parameters from the snapshot in the store. Other items could be
 * returned such as route parameters and static route data if needed.
 */

export interface AppRouterState {
    url: string;
    params: Params;
    queryParams: Params;
}

@Injectable()
export class AppRouterStateSerializer implements RouterStateSerializer<AppRouterState> {
    public serialize(routerState: RouterStateSnapshot): AppRouterState {
        let route = routerState.root;

        while (route.firstChild) {
            route = route.firstChild;
        }

        const { url, root: { queryParams } } = routerState;
        const { params } = route;

        // Only return an object including the URL, params and query params
        // instead of the entire snapshot
        return { url, params, queryParams };
    }
}
